import { render, staticRenderFns } from "./PermissionConfig.vue?vue&type=template&id=065fd108&scoped=true&"
import script from "./PermissionConfig.vue?vue&type=script&lang=js&"
export * from "./PermissionConfig.vue?vue&type=script&lang=js&"
import style0 from "./PermissionConfig.vue?vue&type=style&index=0&id=065fd108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fd108",
  null
  
)

export default component.exports